!function ($) {

	"use strict";

	var Typeahead = function (element, options) {
		this.$element = $(element)
		this.options = $.extend({}, $.fn.typeahead.defaults, options)
		this.matcher = this.options.matcher || this.matcher
		this.sorter = this.options.sorter || this.sorter
		this.highlighter = this.options.highlighter || this.highlighter
		this.updater = this.options.updater || this.updater
		this.$menu = $(this.options.menu).appendTo('body')
		this.source = this.options.source
		this.shown = false
		this.listen()
	}

	Typeahead.prototype = {
		constructor: Typeahead,
		select: function (e) {
			var val = this.$menu.find('.active')
			this.$element
				.val(this.updater(val, e))
				.change()
			return this.hide()
		},
		updater: function (item, e) {
			return item
		},
		show: function () {
			this.$menu.show()
			this.shown = true
			return this
		},
		hide: function () {
			this.$menu.hide()
			this.shown = false
			return this
		},
		lookup: function (event) {
			var items
			this.query = this.$element.val()
			if (!this.query || this.query.length < this.options.minLength) {
				return this.shown ? this.hide() : this
			}
			items = $.isFunction(this.source) ? this.source(this.query, $.proxy(this.process, this)) : this.source
			return items ? this.process(items) : this
		},
		process: function (items) {
			// track search on each result refresh
			trackSearch(this.query);
			this.itemCount = items.length
			var that = this
			items = $.grep(items, function (item) {
				return that.matcher(item)
			})
			items = this.sorter(items)
			if (items.length == 0) {
				this.noresult().show()
				return this
				//return this.shown ? this.hide() : this
			}
			return this.render(items.slice(0, this.options.items)).show()
		},
		matcher: function (item) {
			return ~item[this.options.valueKey].toLowerCase().indexOf(this.query.toLowerCase())
		},
		sorter: function (items) {
			var beginswith = []
				, caseSensitive = []
				, caseInsensitive = []
				, item
			while (item = items.shift()) {
				if (!item[this.options.valueKey].toLowerCase().indexOf(this.query.toLowerCase())) beginswith.push(item)
				else if (~item[this.options.valueKey].indexOf(this.query)) caseSensitive.push(item)
				else caseInsensitive.push(item)
			}
			return beginswith.concat(caseSensitive, caseInsensitive)
		},
		highlighter: function (item) {
			var query = this.query.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&')
			return item.replace(new RegExp('(' + query + ')', 'ig'), function ($1, match) {
				return '<strong>' + match + '</strong>'
			})
		},
		render: function (items) {
			var that = this
			items = $(items).map(function (i, item) {
				var i = $(that.options.item);
				var html = i.html()
				$.each(item, function (key, value) {
					i.attr('data-' + key, value)
					html = html.replace('{' + key + '}', value)
				});
				i.html(html)
				return i[0]
			})
			items.first().addClass('active')

			this.$menu.html(items)

			/* begin: removed condition for test purpose */
			//			if (this.itemCount > that.options.items) {
			//				this.$menu.append(that.options.more)
			//			}
			this.$menu.append(that.options.more)
			/* end: removed condition for test purpose */

			return this
		},
		noresult: function () {
			var html = '<div class="no-result">' + this.options.noresultText + '</div>'
			this.$menu.html(html)
			return this
		},
		next: function (event) {
			var active = this.$menu.find('.active').removeClass('active')
				, next = active.next()
			if (!next.length) {
				next = $(this.$menu.find('li')[0])
			}
			next.addClass('active')
		},
		prev: function (event) {
			var active = this.$menu.find('.active').removeClass('active')
				, prev = active.prev()
			if (!prev.length) {
				prev = this.$menu.find('li').last()
			}
			prev.addClass('active')
		},
		listen: function () {
			this.$element
				.on('blur', $.proxy(this.blur, this))
				.on('keypress', $.proxy(this.keypress, this))
				.on('keyup', $.proxy(this.keyup, this))
			if ($.browser.chrome || $.browser.webkit || $.browser.msie) {
				this.$element.on('keydown', $.proxy(this.keydown, this))
			}
			this.$menu
				.on('click', $.proxy(this.click, this))
				.on('mouseenter', 'li', $.proxy(this.mouseenter, this))
		},
		move: function (e) {
			if (!this.shown) return
			switch (e.keyCode) {
				case 9: // tab
				case 13: // enter
				case 27: // escape
					e.preventDefault()
					break
				case 38: // up arrow
					e.preventDefault()
					this.prev()
					break
				case 40: // down arrow
					e.preventDefault()
					this.next()
					break
			}
			e.stopPropagation()
		},
		keydown: function (e) {
			this.suppressKeyPressRepeat = !~$.inArray(e.keyCode, [40, 38, 9, 13, 27])
			this.move(e)
		},
		keypress: function (e) {
			if (this.suppressKeyPressRepeat) return
			this.move(e)
		},
		keyup: function (e) {
			switch (e.keyCode) {
				case 40: // down arrow
				case 38: // up arrow
					break
				case 9: // tab
				case 13: // enter
					if (!this.shown) return
					this.select(e)
					break
				case 27: // escape
					if (!this.shown) return
					this.hide()
					break
				default:
					this.lookup()
			}
			e.stopPropagation()
			e.preventDefault()
		},
		blur: function (e) {
			var that = this
			setTimeout(function () {
				that.hide()
			}, 150) //leave this to 150! changing this amount will cause a f****** runtime error!!!
		},
		click: function (e) {
			e.stopPropagation()
			e.preventDefault()
			this.select(e)
		},
		mouseenter: function (e) {
			this.$menu.find('.active').removeClass('active')
			$(e.currentTarget).addClass('active')
		}
	}

	$.fn.typeahead = function (option) {
		return this.each(function () {
			var $this = $(this)
				, data = $this.data('typeahead')
				, options = typeof option == 'object' && option
			if (!data) $this.data('typeahead', (data = new Typeahead(this, options)))
			if (typeof option == 'string') data[option]()
		})
	}

	$.fn.typeahead.defaults = {
		source: [],
		valueKey: 'value',
		items: 8,
		menu: '<ul class="typeahead dropdown-menu"></ul>',
		item: '<li><a href="#">{value}</a></li>',
		noresultText: 'no result',
		minLength: 1
	}

	$.fn.typeahead.Constructor = Typeahead
	$(function () {
		$('body').on('focus.typeahead.data-api', '[data-provide="typeahead"]', function (e) {
			var $this = $(this)
			if ($this.data('typeahead')) return
			e.preventDefault()
			$this.typeahead($this.data())
		})
	})

}(window.jQuery);

// search more link
var searchQuery = '';
function getSearchMoreUrl() {
	var url = jQuery('#search-box').data('moreurl');
	var query = jQuery('#search-box').data('value');
	if (query != '') {
        url = Util.addParameter(Util.addParameter(url, 'q', encodeURI(query)), 't', 'global');
	}
	return url;
}

// tracking
var trackSearch = Util.throttle(function (query) {
    if (query && query != '') {
        Track.page(Util.addParameter(Util.addParameter(window.location.pathname + window.location.search, 'q', encodeURI(query)), 't', 'global'));
    }
}, 1000);

var foundSuccess = false;
(function ($) {
	$(function () {
        var fetchResults = Util.throttle(function (query, obj) {
            var wwwDomain = Util.isWwwPage() ? '' : Util.getWwwDomain(),
                endpoint = wwwDomain + "/typo3conf/ext/elasticsearch/proxy.php?t=product&l=" + Util.getLang();
            $.ajax({
                url: endpoint,
                type: "GET",
                dataType: "jsonp",
                data: 'q=' + query,
                success: function (data) {
                    var hits = [];
                    if (data.total > 0) {
                        for (var i = 0; i < data.hits.length; i++) {
                            hits[i] = data.hits[i];
                            if (hits[i].description.length > 55) {
                                hits[i].description = hits[i].description.replace(/^(.{55}[^\s]*).*/, "$1") + "…"
                            }
                            // ensure that all urls point to the www
                            hits[i].packshot = wwwDomain + hits[i].packshot;
                            hits[i].packshot_flyout = wwwDomain + '/' + hits[i].packshot_flyout;
                            hits[i].page = wwwDomain + hits[i].page;
                            hits[i].purchase = wwwDomain + hits[i].purchase;
                        }
                    }
                    obj(hits)
                }
            });
        }, 200);
		$('#search-box').typeahead({
			valueKey: 'title',
			items: 7,
			menu: '<ul id="searchDropDown" class="typeahead dropdown-menu search"></ul>',
			item: '<li><a href="{page}"><span class="packshot"><span class="packshot-align"><img src="{packshot_flyout}" /></span></span><span class="description"><span class="title">{title}</span><br><span class="headline">{description}</span></span></a></li>',
			more: '<li class="more-results" data-page="more"><a href="#" class="more-results-link">' + jQuery('#search-box').data('moretext') + '</a></li>',
			noresultText: jQuery('#search-box').data('noresulttext'),
			source: fetchResults,
			matcher: function (item) {
				return true
			},
			// starts after selecting search result
			updater: function (item, e) {
				// check for search results and only then go to url
				if (item.length > 0) {
					foundSuccess = true;
					$('body,a,button').css('cursor', 'wait')
					var url = item.data('page')
					if (item.data('page') == 'more') {
						url = getSearchMoreUrl()
					}
					if (e.shiftKey && item.data('purchase') != '') {
						url = item.data('purchase')
					}
					Util.goToUrl(url)
					return item.data('title')
				} else {
					if (!Util.isMobile()) {
						Util.goToUrl('/' + Util.getLang() + '/products/')
					}
				}
			}
		});

		// toggle input placeholder-text on focus/on leave
		//$('#search-box').val($('#search-box').data('placeholder'))
		$('#search-box')
			.on('click focusin', function () {
				$(this).attr('value', '')
			})
			.on('keyup', function () {
				$(this).data('value',$(this).attr('value'));
			})
			.on('focusout', function () {
				// reset
				if (!foundSuccess) {
					$('#search-box').val('')
				}
			});

        // toggle mobile search field when magnifying glass icon clicked
		var focused = jQuery('#mobile-product-search-input'),
			mobileSearchBtn = jQuery('#login-cart-search .search-link'),
			mobileSearch = jQuery('#mobile-product-search-container');

		mobileSearchBtn.data('exclusive_popover', {$tip: mobileSearch});

		function mobileSearchHandler() {
			if (mobileSearchBtn.hasClass('dropped')) {
				mobileSearchBtn.trigger($.Event('show.bs.popover'));
			}

			mobileSearch.toggle().toggleClass('in');

			if (mobileSearch.hasClass('in')) {
				focused.trigger('touchstart');
			} else {
				focused.trigger('touchend');
			}

			mobileSearchBtn.toggleClass('dropped');
		}

		mobileSearchBtn.on('click', function (e) {
			e.preventDefault();
			mobileSearchHandler();
		});


        focused.on('touchstart', function () {
            $(this).focus();
        });
        focused.on('touchend', function () {
            $(this).blur();
        });

		/**
		 * Search popover
		 */

		$('#search-link-desktop')
			.popover({
				placement: 'bottom',
				html: true,
				animation: false,
				content: $('#top-search-dropdown'),
				template: '<div class="popover"><div class="arrow"></div><div class="popover-inner"><div class="popover-content"></div></div></div>'
			})
			.exclusivePopover({group: 'metanav'})
			.on('click', function () {
				return false;
			})
			.on('shown.bs.popover', function () {
				$('#search-box').focus();
			});

		$('#search-box').on('click', function (event) {
			event.stopPropagation();
		});


		mobileSearchBtn.exclusivePopover({group: 'metanav', onHide: function() {
			if(mobileSearchBtn.hasClass('dropped')) {
				mobileSearchBtn.trigger('click');
			}
		}});

    })
})(jQuery);
